const question = [
	{
        id: 0,
		question: 'How is your teachers behaviour to you ?',
		options: [
			{ opt: 'Good', mark: 10 },
			{ opt: 'Neutral', mark: 5 },
			{ opt: 'Bad', mark: 3 }
		],
	},
{
        id: 1,
		question: 'How is your school sports facilities ?',
		options: [
			{ opt: 'Better', mark: 10 },
			{ opt: 'Average', mark: 5 },
			{ opt: 'Poor', mark: 3 }
		],
	},
	{
        id: 2,
		question: 'Do you get enough break time ?',
		options: [
			{ opt: 'Yes', mark: 10 },
			{ opt: 'No', mark: 6 }
		],
	},
	{
        id: 3,
		question: 'How your classmates behaviour is towards you ?',
		options: [
			{ opt: 'They are nice to me', mark: 10 },
			{ opt: 'Some of them are nice to me', mark: 7 },
			{ opt: 'They are not fair to me', mark: 3 }
		],
	},
	{
        id: 4,
		question: 'Do you like to hang out with your friends or classmates ?',
		options: [
			{ opt: 'Yes', mark: 10 },
			{ opt: 'No', mark: 2 },
		],
	},
	{
        id: 5,
		question: 'Does anyone in your school bullies you ?',
		options: [
			{ opt: 'Yes', mark: 4 },
			{ opt: 'No', mark: 10 },
		],
	},
	{
        id: 6,
		question: 'Is studying really enjoyable ?',
		options: [
			{ opt: 'Yes', mark: 5 },
			{ opt: 'No', mark: 10 },
			{ opt: 'Some of the subjects is enjoyable', mark: 7 }
		],
	},
	{
        id: 7,
		question: 'Is exams are burden for you ?',
		options: [
			{ opt: 'Yes', mark: 5 },
			{ opt: 'No', mark: 10 },
			{ opt: 'Sometimes', mark: 7 }
		],
	},
	{
        id: 8,
		question: 'Do you ever get frustrated because of homework or exams or studies ?',
		options: [
			{ opt: 'Yes', mark: 5 },
			{ opt: 'No', mark: 10 },
		],
	},
	{
        id: 9,
		question: 'What is your parents reaction when your result didnt fullfill your parents expectation ?',
		options: [
			{ opt: 'They encourages me to do better next time', mark: 10 },
			{ opt: 'They gets angry', mark: 5 },
			{ opt: 'They physically hurts me sometime', mark: 2 }
		],
	},
]

export default question